import { Share2, ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

const LinksPage = () => {
  const navigate = useNavigate();
  const mediaLinks = [
    {
      name: "Spotify",
      icon: (
        <svg viewBox="0 0 24 24" className="w-10 h-10 fill-current">
          <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z"/>
        </svg>
      ),
      url: "https://open.spotify.com/artist/6qouo4AZG13z92FE3e8Abn?si=pjqNTKPgSHupRMTvpr3T3w",
      gradient: "from-green-600 to-green-800",
      hoverGradient: "hover:from-green-500 hover:to-green-700",
      description: "Lyt til vores playlister og musik",
      introText: "Nyd vores musik på turen.",
      featured: true,
    },
    {
      name: "YouTube",
      icon: (
        <svg viewBox="0 0 24 24" className="w-10 h-10 fill-current">
          <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
        </svg>
      ),
      url: "https://www.youtube.com/watch?v=9stUIbnKJFo",
      gradient: "from-red-600 to-red-800",
      hoverGradient: "hover:from-red-500 hover:to-red-700",
      description: "Se videoer fra vores ture og events",
      introText: "Se hvad The Others laver.",
      featured: false,
    },
    {
      name: "TikTok",
      icon: (
        <svg viewBox="0 0 24 24" className="w-10 h-10 fill-current">
          <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
        </svg>
      ),
      url: "https://www.tiktok.com/@theothers.dk?_r=1&_t=ZN-943TAWcvtm2",
      gradient: "from-gray-900 to-black",
      hoverGradient: "hover:from-gray-800 hover:to-gray-900",
      description: "Følg med i vores dagligdag",
      introText: "Sjov, spas og glimt fra hverdagen.",
      featured: false,
      border: true,
    },
    {
      name: "Facebook",
      icon: (
        <svg viewBox="0 0 24 24" className="w-10 h-10 fill-current">
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
        </svg>
      ),
      url: "https://www.facebook.com/share/g/1HAhbwvoBX/?mibextid=wwXIfr",
      gradient: "from-blue-600 to-blue-800",
      hoverGradient: "hover:from-blue-500 hover:to-blue-700",
      description: "Bliv en del af vores fællesskab",
      introText: "Følg vores dagligdag i klubben.",
      featured: false,
    },
    {
      name: "Instagram",
      icon: (
        <svg viewBox="0 0 24 24" className="w-10 h-10 fill-current">
          <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
        </svg>
      ),
      url: "https://www.instagram.com/the_others_mc?igsh=MWR0ZXk2NTlyeWZ4bA==",
      gradient: "from-pink-600 via-purple-600 to-orange-500",
      hoverGradient: "hover:from-pink-500 hover:via-purple-500 hover:to-orange-400",
      description: "Følg os på Instagram",
      introText: "Billeder og stories fra klubben.",
      featured: false,
    },
  ];

  const footerText = "Husk at tilmelde dig vores nyhedsbrev, så du kan følge med i hvad der sker.";

  return (
    <div className="min-h-screen bg-black" data-testid="links-page">
      {/* Hero Section - Full image display */}
      <div className="relative h-[70vh] min-h-[500px]">
        <button onClick={() => navigate(-1)} className="absolute top-20 left-4 z-30 flex items-center gap-1.5 px-3 py-2 rounded-lg bg-black/40 backdrop-blur-sm text-gray-300 hover:text-white text-sm transition-all" data-testid="back-btn">
          <ArrowLeft className="w-4 h-4" /> Tilbage
        </button>
        <div 
          className="absolute inset-0"
          style={{
            backgroundImage: `url('https://customer-assets.emergentagent.com/job_00f587e7-4714-4720-98a9-b623d9c78756/artifacts/oyeeytxg_IMG_4045.png')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center center',
          }}
        />
        {/* Gradient overlay - starts fading much lower */}
        <div 
          className="absolute inset-0"
          style={{
            background: 'linear-gradient(to bottom, rgba(0,0,0,0.4) 0%, rgba(0,0,0,0.2) 20%, transparent 40%, transparent 80%, rgba(0,0,0,0.9) 95%, rgba(0,0,0,1) 100%)'
          }}
        />
        
        {/* Hero Text - Positioned higher up with better visibility */}
        <div className="absolute top-28 sm:top-32 left-0 right-0 px-6 sm:px-12">
          <div className="max-w-7xl mx-auto">
            <h1 
              className="text-5xl sm:text-7xl font-['Oswald'] font-bold text-white mb-4"
              style={{
                textShadow: '3px 3px 6px rgba(0,0,0,0.9), 0 0 30px rgba(0,0,0,0.8), 0 0 60px rgba(0,0,0,0.6)'
              }}
            >
              MEDIEGARAGE
            </h1>
            <p 
              className="text-xl sm:text-2xl text-white max-w-xl font-medium"
              style={{
                textShadow: '2px 2px 4px rgba(0,0,0,0.9), 0 0 20px rgba(0,0,0,0.8)'
              }}
            >
              Her finder du The Others' musik, videoer og sociale medier.
            </p>
          </div>
        </div>
      </div>

      {/* Media Links Section - moved higher with less padding */}
      <div className="bg-black px-6 sm:px-12 py-10">
        <div className="max-w-3xl mx-auto">
          <div className="flex flex-col gap-10">
            {mediaLinks.map((link, index) => (
              <div key={link.name} className="space-y-3">
                {/* Intro text above button */}
                <p className="text-gray-300 text-lg sm:text-xl font-light pl-2">
                  {link.introText}
                </p>
                
                {/* Media button - all same size */}
                <a
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block relative overflow-hidden rounded-2xl transition-all duration-300 transform hover:scale-[1.02] active:scale-[0.98] group p-8"
                  style={{
                    background: link.name === 'Spotify' 
                      ? 'radial-gradient(ellipse at center, #1DB954 0%, #1DB954 20%, #0a3d1a 60%, #000000 100%)'
                      : link.name === 'YouTube'
                      ? 'radial-gradient(ellipse at center, #FF0000 0%, #FF0000 20%, #4d0000 60%, #000000 100%)'
                      : link.name === 'TikTok'
                      ? 'radial-gradient(ellipse at center, #25F4EE 0%, #FE2C55 20%, #1a1a1a 60%, #000000 100%)'
                      : 'radial-gradient(ellipse at center, #1877F2 0%, #1877F2 20%, #0a2d52 60%, #000000 100%)',
                    boxShadow: '0 10px 40px rgba(0,0,0,0.5), inset 0 2px 0 rgba(255,255,255,0.1), inset 0 -2px 0 rgba(0,0,0,0.2)',
                    border: '1px solid rgba(255,255,255,0.1)',
                  }}
                  data-testid={`media-link-${link.name.toLowerCase()}`}
                >
                  {/* Metallic shine effect on hover */}
                  <div className="absolute inset-0 opacity-0 group-hover:opacity-30 transition-opacity duration-500"
                    style={{
                      background: 'radial-gradient(ellipse at center, rgba(255,255,255,0.3) 0%, transparent 70%)',
                    }}
                  />
                  
                  {/* Content */}
                  <div className="relative flex items-center gap-6">
                    <div className="text-white p-4 rounded-xl bg-white/10 backdrop-blur-sm"
                      style={{
                        boxShadow: 'inset 0 2px 4px rgba(255,255,255,0.1), inset 0 -2px 4px rgba(0,0,0,0.2)'
                      }}
                    >
                      {link.icon}
                    </div>
                    <div className="flex-1">
                      <h3 className="font-['Oswald'] font-bold text-white text-3xl">
                        {link.name}
                      </h3>
                      <p className="text-white/80 text-lg">
                        {link.description}
                      </p>
                    </div>
                    <div className="text-white/60 group-hover:text-white transition-colors">
                      <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                      </svg>
                    </div>
                  </div>

                  {/* Featured badge - only for Spotify */}
                  {link.featured && (
                    <div className="absolute top-4 right-4 bg-white/20 backdrop-blur-sm px-3 py-1 rounded-full">
                      <span className="text-white text-sm font-medium">Anbefalet</span>
                    </div>
                  )}
                </a>
                
                {/* Footer text - only under the last button (Facebook) */}
                {index === mediaLinks.length - 1 && (
                  <p className="text-gray-500 text-sm pl-2 italic">
                    {footerText}
                  </p>
                )}
              </div>
            ))}
          </div>

          {/* Bottom section */}
          <div className="mt-16 text-center">
            <p className="text-gray-400 text-base mb-6">
              Følg os på alle platforme for at holde dig opdateret
            </p>
            <div className="flex justify-center gap-6">
              {mediaLinks.map(link => (
                <a
                  key={`icon-${link.name}`}
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-500 hover:text-white transition-colors p-2"
                >
                  <div className="w-7 h-7">{link.icon}</div>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};



export default LinksPage;
